import { useState } from 'react';

type ErrorState = {
  name: string;
  message: string;
};

const useError = (): [ErrorState | null, (name: string, message: string) => void] => {
  const [error, setError] = useState<ErrorState | null>(null);

  const setCustomError = (name: string, message: string) => {
    setError({ name, message });
  };

  return [error, setCustomError];
};

export default useError;